import React, { type FC } from 'react';

import { Checkbox } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import clx from 'classnames';
import { filterInterfaces, getSupportedSurfaces, ImplicitSurface, Surface } from 'client/lib/surfaces';
import * as keyset from 'i18n/AliceSkillForm';

import { Field } from '../Field/Field';

import styles from './InterfaceSelector.module.scss';

const t = i18n(keyset);

const SCREEN = 'screen';

const getSurfaceIcons = () => [
    {
        title: t('surface-windows'),
        surface: ImplicitSurface.Desktop,
        Icon: (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="#3697F1"
                    fillOpacity="0.15"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20 11H12C11.1716 11 10.5 11.6716 10.5 12.5V16.5C10.5 17.3284 11.1716 18 12 18H20C20.8284 18 21.5 17.3284 21.5 16.5V12.5C21.5 11.6716 20.8284 11 20 11ZM12 9.5C10.3431 9.5 9 10.8431 9 12.5V16.5C9 18.1569 10.3431 19.5 12 19.5H15.25V21H12.75C12.3358 21 12 21.3358 12 21.75C12 22.1642 12.3358 22.5 12.75 22.5H19.25C19.6642 22.5 20 22.1642 20 21.75C20 21.3358 19.6642 21 19.25 21H16.75V19.5H20C21.6569 19.5 23 18.1569 23 16.5V12.5C23 10.8431 21.6569 9.5 20 9.5H12Z"
                    fill="#348BDC"
                />
            </svg>
        ),
    },
    {
        title: t('surface-ya-app-short'),
        surface: ImplicitSurface.Mobile,
        Icon: (
            <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16Z"
                    fill="#3697F1"
                    fillOpacity="0.15"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M20.5 11.5L20.5 20.5C20.5 21.3284 19.8284 22 19 22L14 22C13.1716 22 12.5 21.3284 12.5 20.5L12.5 11.5C12.5 10.6716 13.1716 10 14 10L19 10C19.8284 10 20.5 10.6716 20.5 11.5ZM19 8.5C20.6569 8.5 22 9.84315 22 11.5L22 20.5C22 22.1569 20.6569 23.5 19 23.5L14 23.5C12.3431 23.5 11 22.1569 11 20.5L11 11.5C11 9.84315 12.3431 8.5 14 8.5L19 8.5ZM14.75 19C14.3358 19 14 19.3358 14 19.75C14 20.1642 14.3358 20.5 14.75 20.5L18.25 20.5C18.6642 20.5 19 20.1642 19 19.75C19 19.3358 18.6642 19 18.25 19L14.75 19Z"
                    fill="#348BDC"
                />
            </svg>
        ),
    },
    {
        title: t('surface-navi'),
        surface: Surface.Navigator,
        Icon: (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="#3697F1"
                    fillOpacity="0.15"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.1608 21.1343L14.5 17.5L10.8657 16.8392C9.78533 16.6428 9 15.7018 9 14.6037C9 13.6422 9.60511 12.7848 10.511 12.4628L19.8688 9.13553C20.1211 9.04584 20.3868 9 20.6546 9C21.9499 9 23 10.0501 23 11.3454C23 11.6132 22.9542 11.8789 22.8645 12.1312L19.5372 21.489C19.2152 22.3949 18.3578 23 17.3963 23C16.2982 23 15.3572 22.2147 15.1608 21.1343ZM18.1239 20.9865L21.4511 11.6287C21.4835 11.5377 21.5 11.4419 21.5 11.3454C21.5 10.8785 21.1215 10.5 20.6546 10.5C20.5581 10.5 20.4623 10.5165 20.3713 10.5489L11.0135 13.8761C10.7057 13.9855 10.5 14.2769 10.5 14.6037C10.5 14.9769 10.7669 15.2967 11.1341 15.3634L14.7683 16.0242L15.79 16.21L15.9758 17.2317L16.6366 20.8659C16.7033 21.2331 17.0231 21.5 17.3963 21.5C17.7231 21.5 18.0145 21.2943 18.1239 20.9865Z"
                    fill="#348BDC"
                />
            </svg>
        ),
    },
    {
        title: t('surface-station'),
        surface: Surface.Station,
        Icon: (
            <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0.5 16C0.5 7.16344 7.66344 0 16.5 0C25.3366 0 32.5 7.16344 32.5 16C32.5 24.8366 25.3366 32 16.5 32C7.66344 32 0.5 24.8366 0.5 16Z"
                    fill="#3697F1"
                    fillOpacity="0.15"
                />
                <path
                    d="M12.0344 11.7367C13.9 12.8289 15.3885 13.375 16.4998 13.375C17.611 13.375 19.0995 12.8289 20.9651 11.7367C21.2734 11.5563 21.6875 11.6326 21.89 11.9072C21.9616 12.0043 21.9998 12.1179 21.9998 12.234V19.6765C21.9998 20.2377 21.6976 20.7649 21.1874 21.094C19.2173 22.3647 17.6548 23 16.4998 23C15.3447 23 13.7822 22.3647 11.8121 21.094C11.3019 20.7649 10.9998 20.2377 10.9998 19.6765L10.9998 12.234C10.9998 11.9054 11.2988 11.639 11.6676 11.639C11.798 11.639 11.9254 11.673 12.0344 11.7367ZM16.4998 12.15C14.764 12.15 13.3569 11.4448 13.3569 10.575C13.3569 9.70515 14.764 9 16.4998 9C18.2355 9 19.6426 9.70515 19.6426 10.575C19.6426 11.4448 18.2355 12.15 16.4998 12.15Z"
                    fill="#348BDC"
                />
            </svg>
        ),
    },
    {
        title: t('surface-auto'),
        surface: Surface.Auto,
        Icon: (
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
                    fill="#3697F1"
                    fillOpacity="0.15"
                />
                <path
                    d="M16.0001 19.6611C13.3339 19.6611 11.2317 23.0481 9.32432 20.6288C9.12752 20.3792 9.02716 20.0781 9.007 19.7377C8.94405 18.6744 9.6762 17.7608 10.3227 16.9144C11.6505 15.1758 13.094 13.0782 14.2383 11.5434C15.2151 10.2329 16.8038 10.2123 17.8233 11.49C19.1303 13.128 20.7872 15.4306 22.0426 17.2478C22.4666 17.8617 22.8736 18.5139 22.9763 19.2529C23.0517 19.7952 22.9736 20.2663 22.6759 20.6288C20.6891 23.0481 18.6664 19.6611 16.0001 19.6611Z"
                    stroke="#348BDC"
                    strokeWidth="1.3"
                />
            </svg>
        ),
    },
];

const InterfaceCheckbox: FC<InterfaceSelectorProps> = ({ values, onChange, disabled }) => (
    <Checkbox
        name={SCREEN}
        checked={values.includes(SCREEN)}
        disabled={disabled}
        onChange={() => onChange(values.includes(SCREEN) ? values.filter((x) => x !== SCREEN) : values.concat(SCREEN))}
        size="l"
    >
        {t('surface-option-need-screen')}
    </Checkbox>
);

interface SurfaceListProps {
    supportedSurfaces: Array<ImplicitSurface | Surface>;
    disabled?: boolean;
}

const SurfaceList: FC<SurfaceListProps> = ({ supportedSurfaces, disabled }) => {
    const surfaceIcons = getSurfaceIcons();

    return (
        <section className={styles.section}>
            <div className={styles.interfacesList__container}>
                {surfaceIcons.map(({ Icon, surface, title }) => (
                    <div
                        aria-disabled={disabled}
                        key={surface}
                        className={clx(
                            styles.interfacesList__item,
                            !supportedSurfaces.includes(surface) && styles.interfacesList__item_disabled,
                        )}
                    >
                        <div>{Icon}</div>
                        {title}
                    </div>
                ))}
            </div>
        </section>
    );
};

interface InterfaceSelectorProps {
    label: string;
    disabled?: boolean;
    values: string[];
    onChange(interfaces: string[]): void;
}

export const InterfaceSelector: React.FC<InterfaceSelectorProps> = (props) => {
    const requiredInterfaces = filterInterfaces(props.values);
    const supportedSurfaces = getSupportedSurfaces(requiredInterfaces);

    return (
        <Field
            fieldTitle={t('header-surfaces')}
            fieldDescription={t('header-surfaces-subtitle')}
            bottomNote={t('message-surfaces-short')}
        >
            <SurfaceList supportedSurfaces={supportedSurfaces} disabled={props.disabled} />
            <InterfaceCheckbox {...props} />
        </Field>
    );
};
